import React, { Component } from 'react';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Typography, Grid, Button } from '@material-ui/core';
import CreateContentModals from '../components/CreateContentModals';
import { connect } from "react-redux";
import ACLService from '../../acl/services/aclService';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import { checkCreateContentAccess } from '../../../utils';

const styles = (theme: Theme) => createStyles({
	center: {
		maxWidth: "315px",
		textAlign: "center"
	},
	img: {
		width: "100%"
	},
	button: {
		marginTop: "25px"
	},
	heading: {
		marginTop: "20px"
	}
});

interface NoContentProps extends WithStyles<typeof styles> {
	isPostExpiryDays: any;
	toggleLicenseExpiredDialog: any;
}

interface NoContentStates {
	createContentOpen: Boolean,
}

class NoContent extends Component<NoContentProps, NoContentStates> {
	constructor(props: NoContentProps) {
		super(props);
		this.state = {
			createContentOpen: false,
		};

		this.createContentOpenHandler = this.createContentOpenHandler.bind(this);
		this.createContentCloseHandler = this.createContentCloseHandler.bind(this);
	}


	createContentOpenHandler = (event: any) => {
		
		if(this.props.isPostExpiryDays){
			this.props.toggleLicenseExpiredDialog(true);
		} else {
			this.setState({
				createContentOpen: true
			});
		}
	};

	createContentCloseHandler = (event: any) => {
		this.setState({
			createContentOpen: false
		});
	};

	render() {
		
		const { classes } = this.props;
		const {
			createContentOpen,
		} = this.state;
		const showCreateContent = checkCreateContentAccess();

		return (
			<>
				
				<Grid container
					spacing={0}
					direction="column"
					alignItems="center"
					justify="center"
					style={{ minHeight: '100vh' }}>
					<Grid item className={classes.center}>
						<img alt="no content" className={classes.img} src="/assets/img/mylibrary/no-content.png" />
						<Typography variant="h6" className={classes.heading} gutterBottom>No Items in your Library</Typography>
						<Typography variant="caption" color="textSecondary" gutterBottom>Get started with authoring and create content now.</Typography>
						{showCreateContent && 
							<Button
								className={classes.button}
								variant="contained"
								color="primary"
								onClick={this.createContentOpenHandler.bind(this)}
							>
								Create Content
							</Button>
						}
					</Grid>
				</Grid>
				<CreateContentModals
					createContentOpen={createContentOpen}
					createContentCloseHandler={this.createContentCloseHandler.bind(this)}
				/>
			</>
		)
	}
}

const mapStateToProps = (state: any) => ({
	isPostExpiryDays: state.loginData.userData.isPostExpiryDays
  });
  
  const mapDispatchToProps = {
	toggleLicenseExpiredDialog
  };

// @ts-ignore
export default connect(
	mapStateToProps,
	mapDispatchToProps
	// @ts-ignore
  )(withStyles(styles)(NoContent));
